import { render, staticRenderFns } from "./modal-share.vue?vue&type=template&id=2c184f8e&"
import script from "./modal-share.vue?vue&type=script&lang=js&"
export * from "./modal-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports